import { useEffect } from 'react';

import { init } from '@/utils/analytics';
import { useTheme } from '@/theme';

export default function AnalyticsProvider() {
    const theme = useTheme();

    function initAnalytics() {
        init(process.env.PUBLIC_GA_ID);
    }

    useEffect(() => {
        try {
            window['ariseInitAnalytics'] = initAnalytics;
            initAnalytics();

            // Listen for analytics consent changes
            window['cbsoptanon']?.ot?.addOnConsentChangedHandler(initAnalytics);
        } catch {}
    }, [theme]);
    return <></>;
}
